import { render, staticRenderFns } from "./opinionp.vue?vue&type=template&id=1f64ac37&scoped=true&"
import script from "./opinionp.vue?vue&type=script&lang=js&"
export * from "./opinionp.vue?vue&type=script&lang=js&"
import style0 from "./opinionp.vue?vue&type=style&index=0&lang=scss&"
import style1 from "./opinionp.vue?vue&type=style&index=1&id=1f64ac37&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f64ac37",
  null
  
)

export default component.exports